import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { shallowEqual, useSelector } from 'react-redux'

import { isAdvancedPlan } from '@/constants/userSubscriptionPlans'
import type { Team } from '@/types'

interface RecrawlAccess {
  allowed: boolean
  pro: boolean
}

// Who may replace the report: the person who owns it, and — when it lives in a
// workspace — anyone on that workspace's team while the team is active. Everyone
// else reads the report and never sees the button.
//
// The crawl is paid for by whoever owns the report, so how many pages it may
// take follows the owner's plan, not the plan of the person who pressed.
export const useRecrawlAccess = (): RecrawlAccess => {
  const ownerId = useSelector(migrationProjectSelector.getProjectOwnerId)
  const ownerPlan = useSelector(migrationProjectSelector.getProjectOwnerPlan)
  const team = useSelector(migrationProjectSelector.getProjectTeam)

  const { teams, userId } = useSelector<
    AppState,
    { teams: Team[]; userId: string | null }
  >(({ auth }) => ({ teams: auth.teams, userId: auth.id }), shallowEqual)

  const membership = team
    ? teams.find((item: Team) => item.id === team.id)
    : null

  const allowed = Boolean(
    userId && (ownerId === userId || membership?.isActive)
  )

  return { allowed, pro: isAdvancedPlan(ownerPlan ?? '') }
}
